import React from 'react'
import { ColumnStartOrder, ColumnName, ColumnNoc, ColumnRank, ColumnResult, ColumnExtendedResult, ColumnRecords, ColumnExpander } from "components/common/TableColumns"
import Label from "components/general/Label"
import { ColumnRemarks } from '../common/TableColumns';

export function heatsColumns(intermediates=[], isMobile,  isLive) {
    return [
        ColumnRank({disableSort: true , hasRankEqual: true}),
        ColumnStartOrder({label: "HeaderLane", disableSort: isMobile ? true : isLive ? false : true}),
        ColumnNoc({disableSort: true}),
        ColumnName({disableSort: true}),
        ColumnResult({label:"HeaderTime", hideIrm: true}),
        ColumnExtendedResult({id:"Penalty", type:"ER_SW", code:"PTY", label:"HeaderPenalties"}),
        //colPoints,
        ColumnRemarks({}),      
        ...getColumns(intermediates, isMobile, isLive),
        ColumnExpander({})
    ];
}

export function summaryColumns() {
    return [
        ColumnRank({disableSort: true , hasRankEqual: true}),
        ColumnNoc({disableSort: true}),
        ColumnName({disableSort: true}),
        ColumnExtendedResult({id:"Time",  code:"TIME", label:"HeaderTime"}),
        ColumnExtendedResult({id:"Penalty",  code:"PTY", label:"HeaderPenalties"}),
        ColumnResult({label:"HeaderSwimmingPoints", headerClassName: 'text-end w-10  mirs-break-line',}),
        ColumnRemarks({headerClassName: 'text-end w-5 align-middle mirs-break-line'})
    ];
}

function getColumns(intermediates, isMobile, isLive){
    return intermediates?.map(intermediate => (
            {
                id: 'Intermediate' + intermediate?.pos,
                Header: intermediate?.pos === 'F' ? <Label data={'HeaderFinish'} /> : intermediate?.value + 'm',
                headerClassName: "text-end w-10",
                className: 'text-end',
                disableSortBy: isMobile ? true : isLive ? false : true,
                accessor: (props) => {
                    const res = props?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === intermediate?.pos);
                    return res?.er_value2 ? Number(res?.er_rank) : 2000;
                },   
                Cell: (props) => {
                    const res = props.cell.row.original?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === intermediate?.pos);
                    const rank = res?.er_rank && res?.er_rankequal === 'Y' ? `=${res?.er_rank}` : res?.er_rank ? res?.er_rank : '';
                    const time =  res?.er_value && rank ? `${res?.er_value}(${rank})` : res?.er_value
  
                    return (<>{time}</>)
                }
            }
        ))
  }
  
  const colPoints = {
        remove: false,
        Header: <Label data="HeaderSwimmingPoints" />,
        className: "text-end",
        headerClassName: "text-end w-5",
        id: 'Points',
        Cell: (props) => {
            const row = props.cell.row.original;
            return <>{row?.points}</>
        }

  }